import React, { Component } from "react";
import { DayPilot, DayPilotCalendar } from "@daypilot/daypilot-lite-react";
import axios from "axios";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import BigCalendar from "react-big-calendar-like-google";

import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Tr,
  Td,
  Table,
  Thead,
  Th,
  Tbody,
} from "@chakra-ui/react";
import { v4 as uuidv4 } from "uuid";
import * as dc from "../lucy/dynamicContent";
//import "react-big-calendar/lib/css/react-big-calendar.css";
//const localizer = momentLocalizer(moment);
//const localizer = momentLocalizer(moment);
import "react-big-calendar-like-google/lib/css/react-big-calendar.css";
BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

/*   reqTrainerData={this.btnTrainers}
          trainerTimeTable={trainerTimeTable}
          trainerStudentse={trainerStudentse}
          allocatedResource={allocatedResource}*/
class Calendar2 extends Component {
  state = {
    trainerDataLoaded: "no",
    resource_id: -1,
    events: [
      {
        start: moment().toDate(),
        end: moment().add(1, "days").toDate(),
        title: "Some title",
      },
    ],
    studentInfo: [],
    trainerTimeTable: [],
    trainerStudentse: [],
    allocatedResource: [],
    btnTrainersColor: "red",
  };
  /*constructor(props) {
    //super(props);
    this.state = {
      events: [
        {
          start: moment().toDate(),
          end: moment().add(1, "days").toDate(),
          title: "Some title",
        },
      ],
    };
  }*/

  componentDidMount() {
    /*this.setState({
      startDate: "2022-02-22",
      endDate: "2022-02-29",
      events: [
        {
          id: 1,
          text: "Event 1 ojweo rjwioeq rjiowjeq riojqwoei riowqej riojqwoi rweqo rjwoeqij rioqwej roiweqoi rjwioeqj roiwjeq",
          start: "2022-02-22T07:00:00",
          end: "2022-02-22T13:00:00",
        },
        {
          id: 2,
          text: "Event 2",
          start: "2022-02-22T13:30:00",
          end: "2022-02-22T15:30:00",
          backColor: "#6aa84f",
        },
        {
          id: 3,
          text: "Event 3",
          start: "2022-02-23T13:30:00",
          end: "2022-02-23T15:30:00",
          backColor: "#6aa84f",
        },
      ],
    });*/
    //this.props.reqTrainerData(this.props.firstname, this.props.lastname);
    //this.getTrainer();
    /*var studentInfo = this.props.trainerStudentse;
    console.log(studentInfo);*/
    this.socketTrainer();
  }

  getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  async socketTrainer() {
    var events = this.props.events;

    if (events) {
    }

    this.props.chatSocket.on("trainerData", (data) => {
      var j = JSON.parse(data);
      this.setState({ trainerTimeTable: j });
      this.updateTrainerEvent();
    });

    this.props.chatSocket.on("trainerDataStudents", (data) => {
      var j = JSON.parse(data);
      var lstStudentsCleaned = [];
      for (var c in j) {
        if (typeof j[c] == "object") {
          lstStudentsCleaned.push(j[c]);
        }
      }
      //console.log(lstStudentsCleaned);
      this.setState({ trainerStudentse: lstStudentsCleaned });
      this.forceUpdate();
    });

    this.props.chatSocket.on("allocatedResource", (data) => {
      var j = JSON.parse(data);
      var lstCleaned = [];
      for (var c in j) {
        if (typeof j[c] == "object") {
          lstCleaned.push(j[c]);
        }
      }

      this.setState({
        allocatedResource: lstCleaned,
        //btnTrainersColor: "teal",
      });
      this.forceUpdate();
    });

    var jString = JSON.stringify({
      firstname: this.props.firstname,
      lastname: this.props.lastname,
      type: "trainer",
    });

    //Rinaldi
    this.props.chatSocket.emit("searchResource", jString);
  }

  async getTrainer() {
    //console.log(this.props.firstname);
    //const { firstname, lastname } = this.state;
    var link =
      "http://60.231.214.234:19012//php/coursecal/searchResources.php?firstname=" +
      this.props.firstname +
      "&lastname=" +
      this.props.lastname;
    const res = await axios.get(link);

    var data = res["data"];
    var currentWeek = this.getMonday(new Date());
    var todayDate = currentWeek.toISOString().slice(0, 10);
    //console.log(data);
    //console.log(currentWeek);
    var link2 =
      "http://60.231.214.234:19012//php/coursecal/trainer.php?resource_id=" +
      data[0]["resource_id"] +
      "&start_date=" +
      todayDate;
    const resGetCCP = await axios.get(link2);
    var data2 = resGetCCP["data"];
    console.log(link2);
    console.log(data2);

    /*title: "Long Event",
        start: new Date(2015, 3, 7),
        end: new Date(2015, 3, 10),*/

    //get resource timetable
    //http://localhost/php/coursecal/trainer.php?resource_id=3&start_date=22-02-22
  }

  btnOpenStatus(status, id) {
    //console.log(status, id);
    //lstOpen[id] = status;
  }

  getTimeTableButton(data) {
    const { trainerStudentse, allocatedResource } = this.state;
    var studentInfo = trainerStudentse;
    //console.log(studentInfo);
    //console.log("si", studentInfo.length);
    var lstIntakeMatch = [];
    var lstSelectedResource = [];

    if (allocatedResource.length > 0) {
      var lstSelectedResourceTmp = [];
      for (var a in allocatedResource) {
        for (var i in allocatedResource[a]) {
          if (
            data["resource_id"] != allocatedResource[a][i]["resource_id"] &&
            data["session_id"] == allocatedResource[a][i]["session_id"]
          ) {
            lstSelectedResourceTmp.push(allocatedResource[a][i]);
          }
        }
      }
      lstSelectedResource = lstSelectedResourceTmp.map((userData) => (
        <Text key={uuidv4()}>
          {userData["resource_full_name"]} - {userData["item_type"]}
        </Text>
      ));
    }

    if (studentInfo.length > 0) {
      for (var i in studentInfo) {
        //console.log(studentInfo[i]);
        for (var sub in studentInfo[i]) {
          if (data["intake_id"] == studentInfo[i][sub]["intake_id"]) {
            lstIntakeMatch.push(studentInfo[i][sub]);
          }
        }
      }

      lstIntakeMatch = lstIntakeMatch.map((userData) => (
        <Tr key={uuidv4()}>
          <Td>{userData["client_name"]}</Td>
          <Td>{userData["client_contact_number"]}</Td>
          <Td>{userData["client_email"]}</Td>
          <Td>{userData["client_full_address"]}</Td>
          <Td>{userData["client_med_condition"]}</Td>
          <Td>{userData["client_medication"]}</Td>
          <Td>{userData["client_eyesight"]}</Td>
          <Td>{userData["book_theory_passed"]}</Td>
          <Td>{userData["book_payment_status"]}</Td>
        </Tr>
      ));
    } else {
      console.log("empty student info");
    }

    return (
      <Box w="100%" overflow="hidden">
        <dc.SlidePanel
          key={uuidv4()}
          btnOpenStatus={this.btnOpenStatus}
          size="full"
          content={
            <Stack>
              <Stack>
                <Text>Session Description</Text>
                <Text>{data["session_description"]}</Text>
              </Stack>
              <Table variant="striped" colorScheme="teal">
                <Thead>
                  <Tr>
                    <Th>Client</Th>
                    <Th>Number</Th>
                    <Th>Email</Th>
                    <Th>Address</Th>
                    <Th>Medical</Th>
                    <Th>Medication</Th>
                    <Th>Eyesight</Th>
                    <Th>Theory</Th>
                    <Th>Pay</Th>
                  </Tr>
                </Thead>
                <Tbody> {lstIntakeMatch}</Tbody>
              </Table>
            </Stack>
          }
          //id={uniBtnDay}
          parentCallback={this.handleCallback}
          testing={false}
          side="top"
          btn1content={
            <Box>
              <Center>Open</Center>
            </Box>
          }
          btn1width="100%"
          //btn1height="100px"
          btn1cs="teal"
          btn2content="Back"
          title={
            <Center w="100%">
              <Stack>
                <Text>{data["program_tdt_short_name"]}</Text>
                <Text>
                  Campus: {data["campus_full_name"]} - intake:{" "}
                  {data["intake_id"]}
                </Text>
                {lstSelectedResource}
              </Stack>
            </Center>
          }
        />
        <Stack>
          <Text>{data["program_tdt_short_name"]}</Text>
          <Text>
            Campus: {data["campus_full_name"]} - intake: {data["intake_id"]}
          </Text>
          {lstSelectedResource}
        </Stack>
      </Box>
    );
  }

  updateTrainerEvent() {
    const { trainerDataLoaded, trainerTimeTable } = this.state;
    var data2 = trainerTimeTable;
    //console.log(data2.length, trainerDataLoaded);
    if (data2.length >= 0 && trainerDataLoaded == "no") {
      //console.log("comeon");
      var lstData = [];
      try {
        for (var l in data2) {
          var session_date = data2[l]["session_date"];
          var session_state_time = data2[l]["session_start_time"];
          var session_duration = data2[l]["session_duration"];
          var program_tdt_full_name = data2[l]["program_tdt_full_name"];
          var timestring2 = session_date + "T" + session_state_time + "Z";
          var travelTime = moment(timestring2)
            .add(session_duration, "hours")
            .format("hh:mm A");
          //console.log("---");
          //console.log(data2[l]);
          //console.log("---");
          var splitTime = travelTime.split(" ")[0].split(":");
          var splitDate = session_date.split("-");
          var splitStartTime = session_state_time.split(":");
          //console.log(splitStartTime);

          let dateStr = session_date,
            timeStr = session_state_time,
            date = moment(dateStr),
            time = moment(timeStr, "HH:mm");

          date.set({
            hour: time.get("hour"),
            minute: time.get("minute"),
            second: time.get("second"),
          });

          let futuredateStr = session_date,
            futuretimeStr = session_state_time,
            futuredate = moment(futuredateStr),
            futuretime = moment(futuretimeStr, "HH:mm");

          futuredate.set({
            hour: futuretime.get("hour"),
            minute: futuretime.get("minute"),
            second: futuretime.get("second"),
          });

          var futureTime = futuredate.add(session_duration, "hours");
          //console.log(futureTime.hour());
          var newObj = {
            title: this.getTimeTableButton(data2[l]),
            start: new Date(
              date.year(),
              date.month(),
              splitDate[2],
              date.hour(),
              date.minute()
            ),
            end: new Date(
              date.year(),
              date.month(),
              splitDate[2],
              futureTime.hour(),
              futureTime.minute()
            ),
            allDay: false,
            bgColor: "#066A00",
          };
          lstData.push(newObj);
          //console.log(splitTime);
        }
        //console.log(lstData);
        this.setState({ events: lstData, trainerDataLoaded: "yes" });
        //this.forceUpdate();
      } catch {
        console.log("objcal2: 345");
      }
    }
  }

  renders() {
    const { events } = this.state;
    return <div></div>;
  }
  render() {
    const { events, dataLoaded } = this.state;
    //console.log(events);

    const eventss = [
      {
        title: "All Day Event very long title",
        bgColor: "#066A00",
        allDay: true,
        start: new Date(2015, 3, 0),
        end: new Date(2015, 3, 1),
      },
    ];
    try {
      return (
        <div {...this.props}>
          <BigCalendar
            selectable
            events={events}
            defaultView="day"
            //views={["week", "day"]}
            scrollToTime={new Date()}
            defaultDate={new Date()}
            //onSelectEvent={(event) => alert(event.title)}
            /* onSelectSlot={(slotInfo) =>
              alert(
                `selected slot: \n\nstart ${slotInfo.start.toLocaleString()} ` +
                  `\nend: ${slotInfo.end.toLocaleString()}` +
                  `\naction: ${slotInfo.action}`
              )
            }*/
          />
        </div>
      );
    } catch {
      return <Text>Broke</Text>;
    }
  }
}

/*<Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: "100vh" }}
          //views={["agenda"]}
          //defaultView={"agenda"}
        />*/

/* <Calendar
        localizer={localizer}
        defaultDate={new Date()}
        defaultView="month"
        events={events}
        style={{ height: "100vh" }}
      />*/

export default Calendar2;
